<section class="details__main">
    <a [routerLink]="['']"> <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px">
            <path fill="#f0f0f0" d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
        </svg>Voltar</a>
        <app-post imgDetail={{imgDetail}} dateDetail={{dateDetail}} titleDetail={{titleDetail}}
        contentDetail={{contentDetail}}></app-post>
</section>